import { Actions, createEffect, ofType } from '@ngrx/effects';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { mergeMap, Observable } from 'rxjs';
import { Action } from '@ngrx/store';

import { GuestCartActions } from '../actions';
import { IGuestCartResponse } from '../models/guest.models';
import { MarketingFacade } from '../facades/marketing.facade';

@Injectable({
  providedIn: 'root',
})
export class GuestCartEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly marketingFacade: MarketingFacade = inject(MarketingFacade);

  readonly loadGuestCart$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(GuestCartActions.loadGuestCart),
      mergeMap(action => this.marketingFacade.getGuestCartById(action.guestUserId, action.guestCartId).pipe(
        map((guestCartResponse: IGuestCartResponse) => {
          return GuestCartActions.loadGuestCartSuccess({guestCartResponse});
        }),
      )),
    ));
}
